export const categoryList = [
  {
    id: 'prod', slug: 'producer', name: 'プロデューサー', pickup: true,
    description: 'あなたのアイディアを実現するため、方向性の相談から完パケまでをサポートし、楽曲のプロデュースを行います。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-music-producer-85',
    seo: {
      title: '楽曲制作の方向性に迷ったらプロデューサーに相談',
      description: '楽曲制作を総合的に支えるプロデューサーを探してみませんか？曲作りの方向性やリリース戦略まで相談できます。気軽に依頼して、あなたの音楽を形にしましょう。',
    },
  },
  {
    id: 'sing', slug: 'singer', name: 'シンガー', pickup: true,
    description: '様々なジャンルを歌い分け、仮歌入れやバックコーラスなど、あなたの要望に合った内容で、豊かな歌声を提供します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-singer-86',
    seo: {
      title: 'プロシンガーへの歌唱依頼・仮歌収録をオンラインで',
      description: 'あなたの曲をプロの歌声で完成させましょう。シンガーに依頼して、本格的な歌唱を実現。仮歌・本番歌唱どちらも相談可能です。',
    },
  },
  {
    id: 'lyric', slug: 'lyricist', name: '作詞家', pickup: true,
    description: '言葉のクリエイターがあなたの楽曲の世界観に合った歌詞を提供します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-lyricist-87',
    seo: {
      title: 'メロディにぴったりの歌詞をプロの作詞家が提案',
      description: 'あなたのメロディに言葉をのせませんか？ プロの作詞家が、楽曲に最適な歌詞を提案します。今すぐ作詞家を探して、オリジナル曲制作をスタートしましょう。',
    },
  },
  {
    id: 'songw', slug: 'song-writer', name: '作曲家', pickup: true,
    description: 'メロディーメイクからトラック制作、あなたの要望に合った楽曲を制作します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-composer-88',
    seo: {
      title: '曲づくりのアイデアを形にするプロの作曲家が見つかる',
      description: 'オリジナル曲を作ってみませんか？ プロ作曲家に依頼して、世界に一つだけの楽曲を完成させましょう。',
    },
  },
  {
    id: 'mixe', slug: 'mix-engineer', name: 'ミックスエンジニア', pickup: true,
    description: '各楽器の調整や加工を行い、楽曲を立体的に仕上げ、あなたの楽曲をプロクオリティに仕上げます。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-mixing-engineer-89',
    seo: {
      title: 'ボーカル・楽器をクリアに整えるプロのミックス依頼',
      description: '音源をもっと聴きやすく仕上げませんか？ プロのミックスエンジニアが最適な音質を実現。まずは気軽に依頼してみましょう。',
    },
  },
  // { id: 'musician', slug: 'studio-musician', name: 'スタジオミュージシャン', pickup: true },
  {
    id: 'guitar', slug: 'guitarist', name: 'ギタリスト', pickup: true,
    description: 'プロならではのギタースキルで、あなたの楽曲にプロクオリティのギターサウンドを提供します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-studio-musician-92',
    seo: {
      title: 'ギター演奏・録音の依頼はプロのギタリストにお任せ',
      description: '楽曲に本格的なギターサウンドを追加しませんか？ プロギタリストが演奏から録音までサポートします。まずは気軽に相談してみましょう。',
    },
  },
  {
    id: 'drum', slug: 'drummer', name: 'ドラマー', pickup: true,
    description: 'プロならではのドラミングスキルで、あなたの楽曲にプロクオリティのドラムサウンドを提供します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-studio-musician-92',
    seo: {
      title: 'ドラム演奏・打ち込み依頼で楽曲に迫力をプラス',
      description: '楽曲に本格的なリズムを追加しませんか？ プロドラマーが生演奏や打ち込みでサポートします。ドラム演奏の依頼を今すぐしてみましょう。',
    },
  },
  {
    id: 'beat', slug: 'beat-maker', name: 'ビートメーカー', pickup: true,
    description: 'ラップで使用するビートや、EDM などのトラックメイキングなど。あなたのパフォーマンスを引き立たせるトラックを制作します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-beatmaker-91',
    seo: {
      title: 'ヒップホップ・EDM・Lo-fiビートなどの制作依頼はプロのビートメーカーに',
      description: 'あなたの楽曲にオリジナルビートを追加。プロのビートメーカーに依頼して、理想のトラックを作りましょう。',
    },
  },
  {
    id: 'master', slug: 'mastering-engineer', name: 'マスタリングエンジニア', pickup: true,
    description: '楽曲の最終調整、さらに適切な最終音源の書き出しを行い、あなたの楽曲の品質を向上させます。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-mastering-engineer-90',
    seo: {
      title: '楽曲の最終仕上げはマスタリングエンジニアに依頼',
      description: 'あなたの音楽をリスナーに届ける最終工程。クリエイターにマスタリングを依頼して、音質を整えましょう。今すぐ相談可能です。',
    },
  },
  {
    id: 'vocalop', slug: 'vocalop', name: 'ボカロP', pickup: false,
    description: 'ボーカロイドを使った楽曲制作を行います。ボカロ曲の制作から、ボカロを使った楽曲のアレンジまで幅広く対応します。',
    blogUrl: 'https://blog.onlive.studio/what-is-vocalo-p-142',
    seo: {
      title: 'ボカロ曲制作・ボカロアレンジの依頼はプロのボカロPに',
      description: 'あなたの楽曲にボーカロイドを取り入れませんか？ プロのボカロPが、魅力的なボカロ曲を制作します。まずは気軽に相談してみましょう。',
    },
  },
  {
    id: 'keyb', slug: 'keyboardist', name: 'ピアニスト / キーボーディスト', pickup: true,
    description: 'プロならではのピアノ/キーボードスキルで、あなたの楽曲にプロクオリティのピアノサウンドを提供します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-studio-musician-92',
    seo: {
      title: 'ピアノ・キーボード演奏の依頼はプロのキーボーディストに',
      description: '楽曲に本格的なピアノ・キーボードサウンドを追加しませんか？ プロのキーボーディストが演奏から録音までサポートします。まずは気軽に相談してみましょう。',
    },
  },
  {
    id: 'arrange', slug: 'arranger', name: 'アレンジャー', pickup: true,
    description: 'あなたのデモをブラッシュアップ。プロならではの視点から、楽曲の魅力を最大限引き出します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-arranger-93',
    seo: {
      title: '曲の魅力を引き出すプロのアレンジャーを探そう',
      description: '曲をもっと魅力的にアレンジしませんか？ プロのアレンジャーがあなたの楽曲を彩ります。編曲依頼は今すぐ可能です。',
    },
  },
  {
    id: 'bass', slug: 'bassist', name: 'ベーシスト', pickup: true,
    description: 'プロならではのベーススキルで、あなたの楽曲にプロクオリティのベースサウンドを提供します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-studio-musician-92',
    seo: {
      title: 'ベーストラック制作・演奏の相談はプロのベーシストに',
      description: '楽曲に厚みを加えるベースパートをクリエイターに依頼。演奏・打ち込みどちらもOKです。まずは相談してみましょう。',
    },
  },
  // { id: 'piano', slug: 'pianist', name: 'ピアニスト' },
  {
    id: 'brass', slug: 'brass', name: 'ブラス', pickup: false,
    description: 'プロならではの演奏スキルで、あなたの楽曲にプロクオリティのブラスサウンドを提供します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-studio-musician-92',
    seo: {
      title: 'ホーンセクション・ブラス演奏の依頼はプロの奏者に',
      description: '楽曲に迫力のホーンセクションを追加しませんか？ プロのブラス奏者が演奏から録音までサポートします。まずは気軽に相談してみましょう。',
    },
  },
  {
    id: 'strings', slug: 'strings', name: 'ストリングス', pickup: false,
    description: 'プロならではの演奏スキルで、あなたの楽曲にプロクオリティのストリングスサウンドを提供します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-studio-musician-92',
    seo: {
      title: 'ストリングス・弦楽器演奏の依頼はプロの奏者に',
      description: '楽曲に美しいストリングスを追加しませんか？ プロの弦楽器奏者が演奏から録音までサポートします。まずは気軽に相談してみましょう。',
    },
  },
  {
    id: 'perc', slug: 'percussions', name: 'パーカッション', pickup: false,
    description: 'プロならではの演奏スキルで、あなたの楽曲にプロクオリティのパーカッションサウンドを提供します。',
    blogUrl: 'https://blog.onlive.studio/faq-what-is-a-studio-musician-92',
    seo: {
      title: 'パーカッション演奏の依頼はプロの奏者に',
      description: '楽曲にリズムの彩りを加えるパーカッションを追加しませんか？ プロのパーカッショニストが演奏から録音までサポートします。まずは気軽に相談してみましょう。',
    },
  },
  {
    id: 'game', slug: 'game', name: 'ゲーム音楽', pickup: false,
    description: 'プロならではの視点から、ゲームの世界観にマッチした音楽を提供します。ゲーム音楽テイストの楽曲制作もご依頼可能です。',
    seo: {
      title: 'ゲーム音楽制作の依頼はプロの作曲家にお任せ',
      description: 'ゲームの世界観を音楽で表現しませんか？ プロの作曲家が、魅力的なゲーム音楽を制作します。まずは気軽に相談してみましょう。',
    },
  },
  {
    id: 'studio', slug: 'studio', name: 'スタジオ', pickup: false,
    description: 'プロユースの環境と、プロのエンジニアの手によってワンランク上のサウンドを提供します。レコーディング、ミキシング、マスタリングなど、様々な用途に対応可能です。',
    seo: {
      title: 'レコーディング・ボーカル録音・ナレーション収録まで対応可能',
      description: 'プロユースのスタジオで録音してみませんか？エンジニア常駐で安心。今すぐスタジオを予約・相談できます。',
    },
  },
  // { id: 'chorus', slug: 'chorus', name: 'コーラス' },
  {
    id: 'other', slug: 'other', name: 'その他', pickup: false,
    description: 'レッスン、ポスプロ、ケーブル制作...などなど、カテゴリーに収まらない様々なサービスを提供します。',
    seo: {
      title: '音楽・映像制作に関する様々なサービスを提供',
      description: '音楽・映像制作に関する様々なサービスを提供。レッスン、ポスプロ、ケーブル制作など、カテゴリーに収まらない多様なニーズに対応します。',
    },
  },
] as const

export type TCategoryName = typeof categoryList[number]['name']

export const categoryNameList: TCategoryName[] = categoryList.map((cat) => cat.name)
